export enum InterviewCalendarAccess {
  Public = 'public',
  Anonymous = 'anonymous',
}
